/**
 * T 배열이 1개 이면 queryString parse에 의해 string으로 반환되어서 배열로 변환하는 함수
 */
export const allIcxInfoParamsDTO = <T>(filterOptions: T[] | T | null) => {
  if (!filterOptions) {
    return null;
  }

  return Array.isArray(filterOptions) ? filterOptions : [filterOptions];
};

export const fullinvestigationCompanyScaleToString = (
  value: string | null | undefined
) => {
  switch (value) {
    case '1':
      return '대기업';
    case '2':
      return '중기업';
    case '3':
      return '소기업';
  }
  return '-';
};

export const basicCityToString = (value: string | null | undefined) => {
  if (value === '') {
    return '-';
  }

  return value;
};

export const employees2020FullTimeTotalToString = (
  value: string | null | undefined
) => {
  if (!value) {
    return '-';
  }
  return value;
};

export const removeStringPrevDot = (value: string | null | undefined) => {
  if (!value) {
    return '-';
  }

  const dotIndex = value.indexOf('.');

  return value.slice(dotIndex + 1).trim();
};
